"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactRouterRedux = require("react-router-redux");

var _underscore = require("underscore");

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _RouteGenerators = require("lead-flows-ui/lib/RouteGenerators");

// TODO use ui-addon-react-router or some other compostion of react-router Link component
// Handle in-app routing as appropriate.
var AppLink =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(AppLink, _PureComponent);
  (0, _createClass2.default)(AppLink, null, [{
    key: "propTypes",
    get: function get() {
      return {
        children: _react.PropTypes.node,
        href: _react.PropTypes.string.isRequired,
        onClick: _react.PropTypes.func,
        showAsButton: _react.PropTypes.bool,
        target: _react.PropTypes.string,
        use: _react.PropTypes.string // eslint-ignore-line

      };
    }
  }, {
    key: "contextTypes",
    get: function get() {
      return {
        store: _react.PropTypes.shape({
          dispatch: _react.PropTypes.func.isRequired
        })
      };
    }
  }]);

  function AppLink() {
    var _this;

    (0, _classCallCheck2.default)(this, AppLink);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AppLink).call(this));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(AppLink, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.context.store) {
        LOG.warnInApp('AppLink is being used outside of the store context.', 'In-app routing wont work.', 'This should ONLY be the case if this is running inside of a unit test.');
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      var _this$props = this.props,
          href = _this$props.href,
          onClick = _this$props.onClick,
          target = _this$props.target; // Don't handle cmd-clicks.

      var isNewWindowRequest = // Cmd-click.
      event.metaKey || // Middle-mouse-button click.
      event.button === 1 || // Anchor points to new window.
      target === '_blank';

      if (isNewWindowRequest) {
        return;
      } // Points outside of app. We don't want to handle it.


      if (!(0, _RouteGenerators.isAppRoute)(href)) {
        return;
      } // Trigger `onClick` prop if given.


      if (onClick) {
        onClick(event);
      } // The `onClick` handler `preventDefault`ed. We shouldn't route.


      if (event.defaultPrevented) {
        return;
      }

      this.routeInApp(href); // Prevent the browser from handling the event and routing away.

      event.preventDefault();
    }
  }, {
    key: "routeInApp",
    value: function routeInApp(href) {
      // The better way of doing this is to connect() all AppLinks to the
      // store. Doing that prevents us from unit-testing any components that
      // use AppLink. We use `this.context` instead to fix that.
      var store = this.context.store;

      if (!store) {
        LOG.error('AppLink: Tried to navigate without being connected to the store.');
        return;
      }

      store.dispatch((0, _reactRouterRedux.push)(href));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          showAsButton = _this$props2.showAsButton;
      var propsToPassDown = (0, _underscore.omit)(this.props, 'showAsButton', 'push', 'onClick');
      var LinkComponent = showAsButton ? _UIButton.default : _UILink.default;
      return _react.default.createElement(LinkComponent, (0, _extends2.default)({}, propsToPassDown, {
        onClick: this.handleClick
      }), children);
    }
  }]);
  return AppLink;
}(_react.PureComponent);

exports.default = AppLink;
module.exports = exports.default;